// @flow
import * as React from 'react';
import clsx from "clsx";
import {RECENT_FILTER_SEARCH_VALUE_STORAGE_KEY} from "util/LocalStorageWrapper";

type Props = {
  tagOpen, inputRef, tagFilterString, setTagFilterString, selectedTagFilterNum, clickTag, tagList, filteredTagList, getTrans
};
export const TagSearch = ({
  tagOpen,
  inputRef,
  tagFilterString,
  setTagFilterString,
  selectedTagFilterNum,
  clickTag,
  tagList,
  filteredTagList,
  getTrans
}: Props) => {
  return (
    <div className="tag-search" style={{display: tagOpen ? 'block' : 'none'}}>
      <div className="tag-input-item">
        <input ref={inputRef} type="text" className="tag-input" value={tagFilterString} onChange={e => {
          setTagFilterString(e.target.value);
        }}/>
      </div>
      <ul className={clsx("tag-last")}>
        {tagFilterString == '' && localStorage.getItem(RECENT_FILTER_SEARCH_VALUE_STORAGE_KEY)?.split(",").map((recentTag, index) => (
          <li key={recentTag} className={`${selectedTagFilterNum === index && 'on'}`} onClick={() => {
            let array = tagList.filter(tag => tag.tag == recentTag);
            if (array[0] == null) {
              alert(getTrans("I18N_SEARCH_ALERT_TAG_INVALID"));
            } else {
              clickTag(tagList.find(tag => tag.tag === recentTag));
            }
          }}>{recentTag}</li>
        ))
        }
      </ul>
      <ul className="tag-plus">
        {tagFilterString != '' && filteredTagList?.map((tag, index) => {
            return <li key={tag.tag} className={`${selectedTagFilterNum === index && 'on'}`} onClick={() => {
              clickTag(tag);
            }}><span>{tag.tag.substring(0, tagFilterString.length)}</span>{tag.tag.substring(tagFilterString.length)}</li>;
          }
        )}
      </ul>
    </div>
  );
};